import { DefaultValues } from 'react-hook-form';
import { IMeasureFormatMenuState } from './validation';
import {
  IMeasureDisplayFormatFieldsFragment,
  Maybe,
} from '../../../../../utils/apollo/graphqlSchema';
import { defaultMeasureDisplayFormatInput } from '../../../../../utils/builder/measures/measureDisplayFormat/utils';

export const getDefaultMeasureFormatMenuState = (
  measureFormat: Maybe<IMeasureDisplayFormatFieldsFragment>,
): DefaultValues<IMeasureFormatMenuState> => {
  if (!measureFormat) {
    return defaultMeasureDisplayFormatInput;
  }

  const { __typename, ...format } = measureFormat;

  return {
    ...defaultMeasureDisplayFormatInput,
    ...format,
  };
};
